import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AuthService } from '../../../api/services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, RouterModule,
    MatCardModule, MatFormFieldModule, MatInputModule,
    MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatSnackBarModule
  ],
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  loading = true;


  constructor(private auth: AuthService) {}

  /**
   * Hand off to the authorization server, which now renders the sign-in form.
   *
   * This component used to draw its own form and POST it to the auth server.
   * That meant /login existed in two places, and on a phone the browser sheet
   * visibly left auth.reservedine.com for reservedine.com to reach this page —
   * reported as "authentication is performed outside the mobile application".
   * The form lives on the authorization server now; this route only kicks off
   * the OAuth flow so that existing links and guard redirects still work.
   */
  ngOnInit(): void {
    this.auth.initiateOAuthLogin();
  }

}
